

<template>
      
      

  <div class="row">
  <div class="col-sm-3 col-lg-3 col-xxl-3" v-for="etkinlik in paginatedetkinlikler" :key="etkinlik.id"  :class="{ 'tableactivetr': etkinlik.id === (etkinlikler.secili && etkinlikler.secili.id) }">
<div class="card card-bordered">
    <div class="card-inner">
        <div class="team">
            <div class="team-status bg-light text-black"></div>
           
            <div class="user-card user-card-s2" @click="detay(etkinlik)">
                <div class="user-avatar md bg-primary"> <img :src="$globalVariable.uploadUrl + etkinlik.logo"  @error="$globalVariable.varsayilanGorsel" alt="">
                </div>
                <div class="user-info">
                    <h6> {{ etkinlik.ad }}</h6><span class="sub-text">Başlama Tarihi  {{$globalVariable.formatDateTime(etkinlik.bastarih)  }}</span>
                    <span class="sub-text">Başlama Tarihi  {{$globalVariable.formatDateTime(etkinlik.bittarih)  }}</span>
                </div>
            </div>
          
          
            <div class="team-view">
              <a href="#" class="btn btn-trigger btn-icon"  @click="detay(etkinlik)">
            <em class="icon ni ni-eye"></em>
          </a>
              <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('etkinlik_duzenle')" @click="duzenle(etkinlik)">
            <em class="icon ni ni-pen"></em>
          </a>
        
     
          <a href="#" class="btn btn-trigger btn-icon" v-if="yetki_kontrol('etkinlik_sil')" @click="sil(etkinlik.id)">
            <em class="icon ni ni-trash-alt"></em>
          </a>
          
                  </div>
        </div>
    </div>
</div>
</div>
</div>



<div class="card-inner">
        <div class="nk-block-between-md g-3">
          <div class="g">
            <ul class="pagination justify-content-center justify-content-md-start">
              <li :class="{ active: page === etkinlikler.seciliSayfa, 'page-item': true }" v-for="page in pages"
                :key="page">
                <a class="page-link" href="#" @click="etkinliklerSayfaDegistir(page)">{{ page }}</a>
              </li>

            </ul>
          </div>

        </div>
      </div>




   

 </template>
 

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';

export default {
  props: {

    etkinlikler:{
      type: Array,
      required: true
    },
    duzenle: Function,
    detay: Function,
    formKaydetSonrasi: Function,
    tur:String,
  },
  computed: {
    filteredetkinlikler() {
      // Arama filtresine göre kullanıcıları filtrele
      return this.etkinlikler.tumu.filter(
        (etkinlik) =>

          etkinlik.ad.toLowerCase() 
          
          .includes(this.etkinlikler.arananKelime.toLowerCase()) ||etkinlik.ad.toLowerCase()
          
          
          .includes(this.etkinlikler.arananKelime.toLowerCase())


    
      );
    },
    paginatedetkinlikler() {
      const start = (this.etkinlikler.seciliSayfa - 1) * this.etkinlikler.sayfadaKayit;
      const end = start + this.etkinlikler.sayfadaKayit;
      return this.filteredetkinlikler.slice(start, end);
    },
    etkinlikler_toplamSayfa() {
      const totalFilteredUsers = this.filteredetkinlikler.length;
      const maxPage = Math.max(Math.ceil(totalFilteredUsers / this.etkinlikler.sayfadaKayit), 1);
      if (this.etkinlikler.seciliSayfa > maxPage) {
        this.etkinliklerSayfaDegistir(maxPage);
      }
      return maxPage;
    },
    pages() {
        const totalPageCount = this.etkinlikler_toplamSayfa;
        const maxVisiblePages = 5;
        const currentPage = this.etkinlikler.seciliSayfa;

        if (totalPageCount <= maxVisiblePages) {
            return Array.from({ length: totalPageCount }, (_, index) => index + 1);
        }

        const pagesBefore = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
        const pagesAfter = Math.min(pagesBefore + maxVisiblePages - 1, totalPageCount);

        return Array.from({ length: pagesAfter - pagesBefore + 1 }, (_, index) => pagesBefore + index);
    },
  
  },
  methods: {
    yetki_kontrol(yetki){
      return yetkiKontrol(yetki);
    },
    async sil(etkinlikId) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });

      if (result.isConfirmed) {
        try {
          await axiosCustom.post("etkinlikler/sil/" + etkinlikId);
          this.$toast.success("Kayıt Silindi");
          this.formKaydetSonrasi();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast.error("Silme hatası");
        }
      }
    },
    etkinliklerSayfaDegistir(page) {
      this.$emit('update:etkinlikler',{
      ...this.etkinlikler,
      seciliSayfa: page
    });
    },
    etkinliklerSayfadaKayitDegistir(value) {
      this.$emit('update:etkinlikler',{
      ...this.etkinlikler,
      sayfadaKayit: value
    });
      this.etkinliklerSayfaDegistir(1);
    },
  },
};
</script>
